import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'users'
})
export class UsersPipe implements PipeTransform {

  transform(users: any, inactive:Boolean, evaluated:Boolean, firstBuy: Boolean) {
    var resp=[];
    var aux=[];
    if(!inactive){
      users.map(
        x=>{
          if(x.active) aux.push(x);
        }
      )
    }
    if(inactive) aux = users;


    if(!evaluated){
      aux.map(
        x=>{
          if(x.role=='client'&&x.firstBuy==firstBuy) resp.push(x);
        }
      )
    }else{
      aux.map(
        x=>{
          if(x.role=='client'||x.role=='evaluated') resp.push(x)
        }
      )
    }

    return resp;

  }

}
